import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import type { ReactNode } from "react";

interface ArticleLayoutProps {
  title: string;
  subtitle?: string;
  heroImage: string;
  heroAlt: string;
  children: ReactNode;
}

export default function ArticleLayout({ title, subtitle, heroImage, heroAlt, children }: ArticleLayoutProps) {
  return (
    <main>
      <Navbar />

      <section className="relative w-full h-[40vh] min-h-[380px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img src={heroImage} alt={heroAlt} className="w-full h-full object-cover object-center" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-[800px] mx-auto pt-12">
          <p className="text-xs font-semibold text-white/60 uppercase tracking-[0.2em] mb-4 font-label">
            Complete Guide &bull; 2026 Edition
          </p>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white font-heading leading-[1.15]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-sm md:text-base text-white/70 max-w-[600px] mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
      </section>

      <article className="py-16 md:py-20 bg-background-100">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-8 font-label flex-wrap">
            <Link to="/" className="hover:text-foreground-800 transition-colors whitespace-nowrap">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">{title}</span>
          </nav>

          <div className="prose-custom space-y-6">
            {children}
          </div>

          {/* Internal Navigation */}
          <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-700 hover:text-foreground-950 transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              Back to OOPBuy Spreadsheet Hub
            </Link>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center h-12 px-6 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Visit Main Platform
            </a>
          </div>
        </div>
      </article>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            Ready to Explore More?
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">
            Browse all categories on the{" "}
            <Link to="/" className="text-accent-600 hover:text-accent-700 font-semibold underline underline-offset-2 transition-colors">
              OOPBuy Spreadsheet Hub
            </Link>{" "}
            or visit the main platform for the latest spreadsheet tools and comparisons.
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="mt-6 inline-flex items-center justify-center h-12 px-8 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now on Kaspreadsheet
          </a>
        </div>
      </section>

      <Footer />
    </main>
  );
}